import tw, { styled } from 'twin.macro'

export const Input = styled('input')`
  ${tw`rounded-lg bg-gray-translucent text-gray-700 text-lg p-4 border border-solid border-gray-500 w-full focus:border-red-500 focus:outline-none font-light`}
`

export const InputSmall = styled('input')`
  ${tw`rounded-lg bg-gray-translucent text-gray-700 text-lg p-2 text-sm border border-solid border-gray-500 w-full focus:border-red-500 focus:outline-none font-light`}
`

export const Textarea = styled('textarea')`
  ${tw`rounded-lg bg-gray-translucent text-gray-700 text-lg p-4 border border-solid border-gray-500 w-full focus:border-red-500 focus:outline-none font-light`}
`

export const Select = styled('select')`
  ${tw`rounded-lg bg-gray-translucent text-gray-700 text-lg p-4 border border-solid border-gray-500 w-full focus:border-red-500 focus:outline-none font-light`}
`

export const Button = styled('button')`
  ${tw`rounded-lg bg-green-500 text-gray-200 text-lg p-4 border border-solid border-gray-500 max-w-full hover:bg-green-600 font-light cursor-pointer`}
`
